module.exports = __webpack_public_path__ + "dee63307.svg";